/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { WindowSize } from '../types';

export function useWindowSize(): WindowSize {
  if (typeof window === 'undefined') {
    return { width: 1200, height: 800 }; // Default values for SSR
  }

  const windowSize = useRef<any>();
  windowSize.current = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  function changeWindowSize() {
    if (windowSize.current)
      windowSize.current = { width: window.innerWidth, height: window.innerHeight };
  }

  React.useEffect(() => {
    changeWindowSize();
    window.addEventListener('resize', changeWindowSize);

    return () => {
      window.removeEventListener('resize', changeWindowSize);
    };
  }, []);

  return windowSize.current;
}
